const baseUrl = 'https://antonyco.com';

export const environment = {
    production: true,
    application: {
        baseUrl,
        name: 'antonyco-web',
        logoUrl: '',
    },
    apis: {
        default: {
            url: '/services',
        },
        imagor: {
            url: '/image-processor',
        },
    },
    remoteEnv: {
        mergeStrategy: 'deepmerge',
        url: 'config/appsettings.json',
    },
}; //as Environment;
